import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BuscadorPEP } from '../models/buscadorPEP';
import { PedidoEspecialPlantaCabecera } from '../models/pedidoEspecialPlantaCabecera';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PEPService {

  private pepServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(
    private httpCliente: HttpClient,
    private configService: ConfigService,
    private tokenService: TokenService
  ) {
    this.pepServerUri = this.apiUrl + '/' + this.configService.PEPURI;
  }

  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }

  aprobarRechazarPedidoItem(codigo: number, codigoItem: number) {
    return this.httpCliente.get(this.pepServerUri + 'AprobarRechazarPedidoItem?codigo=' + codigo + "&codigoItem=" + codigoItem, { headers: this.getHeaders() });
  }

  aprobarPedidoEspecialPlanta(pepc: PedidoEspecialPlantaCabecera) {
    return this.httpCliente.post(this.pepServerUri + 'AprobarPedidoEspecialPlanta', pepc, { headers: this.getHeaders() });
  }

  aprobarIngresadoPedidoEspecialPlanta(pepc: PedidoEspecialPlantaCabecera) {
    return this.httpCliente.post(this.pepServerUri + 'AprobarIngresadoPedidoEspecialPlanta', pepc, { headers: this.getHeaders() });
  }

  rechazarPedidoEspecialPlanta(pepc: PedidoEspecialPlantaCabecera) {
    return this.httpCliente.post(this.pepServerUri + 'RechazarPedidoEspecialPlanta', pepc, { headers: this.getHeaders() });
  }

  rechazarPedidoEspecialPlantaPorCliente(pepc: PedidoEspecialPlantaCabecera) {
    return this.httpCliente.post(this.pepServerUri + 'RechazarPedidoVentaPorCliente', pepc, { headers: this.getHeaders() });
  }

  amPedidoEspecialPlanta(pepc: PedidoEspecialPlantaCabecera) {
    return this.httpCliente.post(this.pepServerUri + 'AMPedidoEspecialPlanta', pepc, { headers: this.getHeaders() });
  }

  aPedidoEspecialPlantaItem(pepc: PedidoEspecialPlantaCabecera) {
    return this.httpCliente.post(this.pepServerUri + 'APedidoEspecialPlantaItem', pepc, { headers: this.getHeaders() });
  }

  mPedidoEspecialPlantaItem(pepc: PedidoEspecialPlantaCabecera) {
    return this.httpCliente.post(this.pepServerUri + 'MPedidoEspecialPlantaItem', pepc, { headers: this.getHeaders() });
  }

  bPedidoEspecialPlantaItem(codigoCabecera: number, codigoItem: number) {
    return this.httpCliente.get(this.pepServerUri + 'BPedidoEspecialPlantaItem?codigoCabecera=' + codigoCabecera + "&codigoItem=" + codigoItem, { headers: this.getHeaders() });
  }

  cPedidosEspecialesPlanta(buscador: BuscadorPEP) {
    return this.httpCliente.post(this.pepServerUri + 'CPedidosEspecialesPlanta', buscador, { headers: this.getHeaders() });
  }

  cPedidoEspecialPlanta(idPais: string, idCompania: string, idSalesOrg: string, idTipoOrden: string, codigo: number) {
    return this.httpCliente.get(this.pepServerUri + 'cPedidoEspecialPlanta?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoOrden=" + idTipoOrden + "&codigo=" + codigo, { headers: this.getHeaders() });
  }

  cPedidoEspecialPlantaItem(codigoItem: number) {
    return this.httpCliente.get(this.pepServerUri + 'CPedidoEspecialPlantaItem?codigoItem=' + codigoItem, { headers: this.getHeaders() });
  }

  cListasPreciosAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, nroCLiente: string, idFormaPago: string, idGrupoCliente: string, idTipoOrden: string, search: string) {
    return this.httpCliente.get(this.pepServerUri + 'CListasPreciosAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCLiente=" + nroCLiente + "&idFormaPago=" + idFormaPago + "&idGrupoCliente=" + idGrupoCliente + "&idTipoOrden=" + idTipoOrden + "&search=" + search, { headers: this.getHeaders() });
  }

  cTerminosPagoTipoListaPrecios(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string) {
    return this.httpCliente.get(this.pepServerUri + 'CTerminosPagoTipoListaPrecios?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoListaPrecios=" + idTipoListaPrecios, { headers: this.getHeaders() });
  }

  cListaPrecioItemsAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string, idTerminoPago: string, idMoneda: string, idPlanta: string, idUbicacionAlmacenamiento: string, search: string) {
    idMoneda = typeof idMoneda == 'undefined' || idMoneda == null ? "" : idMoneda;
    idTerminoPago = typeof idTerminoPago == 'undefined' || idTerminoPago == null ? "" : idTerminoPago;
    idTipoListaPrecios = typeof idTipoListaPrecios == 'undefined' || idTipoListaPrecios == null ? "" : idTipoListaPrecios;
    return this.httpCliente.get(this.pepServerUri + 'CListaPrecioItemsAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoListaPrecios=" + idTipoListaPrecios + "&idTerminoPago=" + idTerminoPago + "&idMoneda=" + idMoneda + "&idPlanta=" + idPlanta + "&idUbicacionAlmacenamiento=" + idUbicacionAlmacenamiento + "&search=" + search, { headers: this.getHeaders() });
  }

  cStoragesLocationsPlanta(idPais: string, idCompania: string, idSalesOrg: string, idPlanta: string) {
    return this.httpCliente.get(this.pepServerUri + 'CStoragesLocationsPlanta?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idPlanta=" + idPlanta, { headers: this.getHeaders() });
  }

  cEstadosItems(idPais: string) {
    return this.httpCliente.get(this.pepServerUri + 'CEstadosItems?idPais=' + idPais, { headers: this.getHeaders() });
  }

  cPedidoEspecialPlantaRetenciones(idPais: string, idCompania: string, idSalesOrg: string, nroPedido: number) {
    return this.httpCliente.get(this.pepServerUri + 'CPedidoEspecialPlantaRetenciones?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroPedido=" + nroPedido, { headers: this.getHeaders() });
  }

  cMotivosDevolucion() {
    return this.httpCliente.get(this.pepServerUri + 'CMotivosDevolucion', { headers: this.getHeaders() });
  }

  aprobarPedidoEspecialPlantaRetenido(pepc: PedidoEspecialPlantaCabecera) {
    return this.httpCliente.post(this.pepServerUri + 'AprobarPedidoEspecialPlantaRetenido', pepc, { headers: this.getHeaders() });
  }

  cCuotasPlantas(idPais: string, idCompania: string, idSalesOrg: string, idPlanta: string, idUbicacionAlmacenamiento: string, idProducto: string) {
    return this.httpCliente.get(this.pepServerUri + 'CCuotasPlantas?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idPlanta=" + idPlanta + "&idUbicacionAlmacenamiento=" + idUbicacionAlmacenamiento + "&idProducto=" + idProducto, { headers: this.getHeaders() });
  }

  aprobarPedidoEspecialPlantaAnticipada(pepc: PedidoEspecialPlantaCabecera) {
    return this.httpCliente.post(this.pepServerUri + 'AprobarPedidoEspecialPlantaAnticipada', pepc, { headers: this.getHeaders() });
  }
 
}